function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { ActionButton, Checkbox, TooltipHost, FontIcon, Stack, Text, ScreenWidthMinXLarge, mergeStyles } from '@fluentui/react';
import SpzaComponent from '@shared/components/spzaComponent';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const classNames = require('classnames-minimal');
const checkboxFilterPadding = mergeStyles({
    padding: '15px 5px',
    [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
        padding: '15px 5px 20px 20px'
    }
});
export class FilterLink extends SpzaComponent {
    getFilterName() {
        return `${this.context.loc(this.props.locKey, this.props.localizedName)}${this.props.activeChildren > 0 ? ` (${this.props.activeChildren})` : ''}`;
    }
    getFilterLabel() {
        const name = this.getFilterName();
        const start = name.toLowerCase().indexOf(this.props.searchValue);
        if (!this.props.searchValue || start === -1) {
            return /*#__PURE__*/ _jsx("span", {
                title: name,
                children: name
            });
        }
        const end = start + this.props.searchValue.length - 1;
        return /*#__PURE__*/ _jsxs("span", {
            children: [
                name.substr(0, start),
                /*#__PURE__*/ _jsx("b", {
                    children: name.substr(start, end - start + 1)
                }),
                name.substr(end + 1),
                ' '
            ]
        });
    }
    renderImpl() {
        var _this_props_link_links, _this_props_link;
        const hostStyles = {
            root: {
                marginLeft: 5
            }
        };
        const checkboxStyles = {
            checkbox: {
                marginRight: 0
            }
        };
        const buttonFocused = !this.props.isGroup && !this.props.isChild;
        return this.props.checkboxTooltip ? this.renderCheckBoxFilter() : /*#__PURE__*/ _jsxs(Stack, {
            horizontal: true,
            verticalAlign: "center",
            className: `${this.props.className} filterLinkButton ${classNames({
                isGroup: this.props.isGroup,
                isChild: this.props.isChild,
                isActive: this.props.isActive
            })}`,
            children: [
                this.props.isChild ? /*#__PURE__*/ _jsx(Stack.Item, {
                    className: "filterCheckbox",
                    onClick: this.props.onClick,
                    children: /*#__PURE__*/ _jsx(Checkbox, {
                        styles: checkboxStyles,
                        checked: this.props.isActive,
                        ariaLabel: this.getFilterName()
                    })
                }) : null,
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: /*#__PURE__*/ _jsxs(ActionButton, {
                        onClick: this.props.onClick,
                        styles: this.styles,
                        "data-is-focusable": buttonFocused,
                        "aria-expanded": ((_this_props_link = this.props.link) === null || _this_props_link === void 0 ? void 0 : (_this_props_link_links = _this_props_link.links) === null || _this_props_link_links === void 0 ? void 0 : _this_props_link_links.length) ? this.props.isActive : undefined,
                        "aria-current": this.props.isActive ? 'page' : undefined,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "filterLabel",
                                children: this.getFilterLabel()
                            }),
                            this.props.tooltip && /*#__PURE__*/ _jsx("div", {
                                tabIndex: 0,
                                children: /*#__PURE__*/ _jsx(TooltipHost, {
                                    styles: hostStyles,
                                    content: this.context.loc(this.props.tooltip, this.props.tooltip),
                                    id: "tooltipContent",
                                    children: /*#__PURE__*/ _jsx(FontIcon, {
                                        iconName: "Info"
                                    })
                                })
                            }),
                            this.props.children && /*#__PURE__*/ _jsx(_Fragment, {
                                children: this.props.children
                            })
                        ]
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0), _define_property(this, "styles", {
            flexContainer: {
                alignItems: this.props.isRoot ? 'baseline' : 'center'
            }
        }), _define_property(this, "renderCheckBoxFilter", ()=>{
            const { isActive, checkboxTooltip, onClick } = this.props;
            return /*#__PURE__*/ _jsxs(Stack, {
                className: checkboxFilterPadding,
                horizontal: true,
                tokens: {
                    childrenGap: 5
                },
                onClick: onClick,
                children: [
                    /*#__PURE__*/ _jsx(Checkbox, {
                        checked: isActive,
                        ariaLabel: this.getFilterName()
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        children: this.getFilterLabel()
                    }),
                    /*#__PURE__*/ _jsx(TooltipHost, {
                        content: checkboxTooltip,
                        id: "tooltipContent",
                        children: /*#__PURE__*/ _jsx(FontIcon, {
                            iconName: "Info"
                        })
                    })
                ]
            });
        });
    }
}
FilterLink.contextTypes = {
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func,
    buildHref: PropTypes.func
};
